import { Component, ReactNode } from 'react'

import moment from 'moment'

import { InsurancePolicyProps } from './StatusSlice'

import SiNo from '../siNo/SiNo'
import Input from '../../libs/ui/inputs/Input'
import {DATE_FORMAT, DATE_PRINT_FORMAT, isNotValidScadenzaPolizza } from '../../libs/validation/dateValidation'

interface PolizzaAttivaState {}


class PolizzaAttiva extends Component<InsurancePolicyProps, PolizzaAttivaState> {

    constructor (props: any) {
        super(props)

        this.isValidDate = this.isValidDate.bind(this)
    }

    render () : ReactNode{
        const NOW = new Date()

        const DATE_START = moment(NOW).format(DATE_FORMAT)
        const DATE_END = moment(NOW).add(1, 'months').format(DATE_FORMAT)

        const DATE_START_FORMATTED = moment(NOW).format(DATE_PRINT_FORMAT)
        const DATE_END_FORMATTED = moment(NOW).add(1, 'months').format(DATE_PRINT_FORMAT)

        return (
            <div className='col-12'>
                <SiNo 
                    id={this.props.siNoId}
                    label={this.props.siNoLabel}
                    name={this.props.siNoId}
                    value={this.props.siNoValue}
                    callback={this.props.siNoCallBack}
                    error={this.props.errorAttiva}
                />
                {this.props.siNoValue === 'si' &&
                    <Input 
                        label={this.props.dataLabel}
                        id={this.props.dataId}
                        name={this.props.dataId}
                        type='date'
                        value={this.props.dataValue}
                        min={DATE_START}
                        max={DATE_END}
                        callback={this.props.dataCallBack}
                        errorDisplayMsg={'tra ' + DATE_START_FORMATTED + ' e ' + DATE_END_FORMATTED}
                        regexp={this.isValidDate}
                        error={this.props.errorScadenza}
                    />
                }
            </div>
        )
    }

    private isValidDate (date: string) {
        if (this.props.siNoValue === 'si') {

            return !isNotValidScadenzaPolizza( date )
        }

        return true
    }
}

export default PolizzaAttiva